import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { z } from 'zod';
import { AuthGuard } from '@/components/auth-guard';
import { ForumComposePage } from '@/features/forum';

const ComposeSearchSchema = z.object({
  kind: z
    .enum(['discussion', 'question', 'announcement', 'survey-link', 'poll', 'ama', 'event-rsvp'])
    .optional(),
  group: z.string().uuid().optional(),
});

export const Route = createFileRoute('/forum_/new')({
  component: ForumNewRoute,
  validateSearch: (search) => ComposeSearchSchema.parse(search),
});

function ForumNewRoute(): ReactNode {
  const search = Route.useSearch();
  return (
    <AuthGuard>
      <ForumComposePage
        {...(search.kind !== undefined ? { kind: search.kind } : {})}
        {...(search.group !== undefined ? { group: search.group } : {})}
      />
    </AuthGuard>
  );
}
